import { ParsedUrlQuery } from 'querystring';
import {
    getAdded,
    getBedsMax,
    getBedsMin,
    getBuyerIncentive,
    getChainFree,
    getFeatures,
    getIncludeSold,
    getIsAuction,
    getIsRetirementHome,
    getIsSharedOwnership,
    getKeywords,
    getNewHomes,
    getPriceFrequency,
    getPriceMax,
    getPriceMin,
    getPropertySubType,
    getPropertyType,
    getReducedPriceOnly
} from '.';

export const getDefaultForSaleFilters = () => {
    return {
        added: '',
        beds_max: '',
        beds_min: '',
        buyer_incentive: '',
        chain_free: '',
        feature: [],
        include_sold: '',
        is_auction: '',
        is_retirement_home: '',
        is_shared_ownership: '',
        keywords: '',
        new_homes: 'include',
        price_frequency: '',
        price_max: '',
        price_min: '',
        property_sub_type: [],
        property_type: 'property',
        reduced_price_only: ''
    };
};

export const getForSaleFilters = (query: ParsedUrlQuery, pathname: string) => {
    return {
        added: getAdded(query),
        beds_max: getBedsMax(query),
        beds_min: getBedsMin(query),
        buyer_incentive: getBuyerIncentive(query),
        chain_free: getChainFree(query),
        feature: getFeatures(query),
        include_sold: getIncludeSold(query),
        is_auction: getIsAuction(query, pathname),
        is_retirement_home: getIsRetirementHome(query),
        is_shared_ownership: getIsSharedOwnership(query),
        keywords: getKeywords(query),
        new_homes: getNewHomes(query, pathname),
        price_frequency: getPriceFrequency(query),
        price_max: getPriceMax(query),
        price_min: getPriceMin(query),
        property_sub_type: getPropertySubType(query),
        property_type: getPropertyType(query),
        reduced_price_only: getReducedPriceOnly(query)
    };
};
